import React from 'react'
import classNames from 'classnames'
import { EyebrowProps } from './Eyebrow.d'
import SparkHeading from '../SparkHeading/SparkHeading'
import Badge from '@toasttab/shared/src/components/atoms/Badge/Badge'

// Component's Render Function with Props
const Eyebrow = ({
  icon,
  badges,
  link,
  variation,
  children,
  content,
  contentClasses,
  componentClass
}: EyebrowProps) => {
  const styleClasses = classRules(variation, componentClass)
  const childrenProp = children || content

  const iconClasses = classNames('inline-block', {
    'mr-[6px]': ['otl-grey', 'otl-grey-bold'].includes(variation),
    'mr-2': variation !== 'otl-grey' && variation !== 'pos-hp',
    'mr-1': variation === 'pos-hp'
  })

  return (
    <div className={styleClasses} data-testid='mds-eyebrow'>
      {icon?.src ? (
        <img
          alt='icon'
          className={iconClasses}
          data-testid='mds-eyebrow-icon'
          height={icon.height}
          src={icon.src}
          title={variation}
          width={icon.width}
        />
      ) : null}
      {link?.url ? (
        <a href={link.url} rel={link.rel} target={link.target}>
          {' '}
          {childrenProp}{' '}
        </a>
      ) : null}
      {!link?.url && contentClasses ? (
        <span className={contentClasses}>{childrenProp}</span>
      ) : null}
      {!link?.url && !contentClasses && <> {childrenProp} </>}
      {badges?.badges && badges.badges.length > 0 ? (
        <>
          {badges.badges.map((badge, index) => (
            <Badge
              badgeColor='bg-sky-0'
              classes='mr-2 mt-3 whitespace-nowrap'
              key={index}
              text={badge}
              uppercase={true}
            />
          ))}
        </>
      ) : null}
    </div>
  )
}

// Create ClassName Object for Styles
const classRules = (variation: string, componentClass?: string) =>
  classNames(componentClass, {
    // test style class
    'inline-flex items-center':
      variation !== 'otl-related-articles' && variation !== 'badges',
    // Styles for otl-grey
    'font-calibre font-normal leading-none tracking-[1.2px] uppercase text-[12px] text-legacy-grey-10 mb-[16px]':
      variation === 'otl-grey',
    'font-sansPro font-semibold uppercase tracking-[1.2px] text-[12px] text-secondary mb-4':
      variation === 'otl-grey-bold',
    'font-sansPro font-semibold leading-none tracking-[1.2px] uppercase text-[12px] text-black mb-[8px]':
      variation === 'otl-black',
    'flex self-start font-sansPro font-semibold leading-none tracking-[1.2px] uppercase text-[12px] text-black mb-[8px]':
      variation === 'otl-related-articles',
    // Styles for otl-orange
    'font-calibre text-otl-topic-label uppercase text-xs text-brand-50 text-toast-orange-500 hover:otl-orange':
      variation === 'otl-orange',
    'mb-4 font-sansPro font-normal text-default text-xs uppercase leading-none tracking-[1.2px]':
      variation === 'ds' || variation === 'badges',
    'mb-2 font-sansPro font-normal text-secondary text-xs':
      variation === 'secondary',
    'mb-2 font-sansPro font-normal text-secondary text-[16px] leading-[100%]':
      variation === 'pos-hp'
  })

// Export Render Function
export default Eyebrow
